// extracted by mini-css-extract-plugin
export default {"item-list":"BeersMobile_item-list__UC1h2","item":"BeersMobile_item__bxbCS","section":"BeersMobile_section__QscPH","category-title":"BeersMobile_category-title__1Pbpr"};